import { styled } from '@linaria/react'

export const Teaser = styled.div`
  color: var(--white);
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  border-radius: 5px;
  padding: 25px;
  position: relative;
  overflow: hidden;
  transition: 0.3s 0.2s ease;
  min-height: 410px;
  height: ${props => (props.isSlider ? '100%' : 'auto')};
  width: ${props => !props.isSlider && 'calc(100% / 4 - 15px)'};

  @media screen and (max-width: 1200px) {
    width: ${props => !props.isSlider && 'calc(100% / 3 - 15px)'};
  }

  @media screen and (max-width: 992px) {
    min-height: 380px;
    width: ${props => !props.isSlider && 'calc(100% / 2 - 10px)'};
  }

  @media screen and (max-width: 576px) {
    min-height: 360px;
    width: ${props => !props.isSlider && '100%'};
  }

  &:hover,
  &:focus {
    padding-bottom: 70px;
    transition: 0.3s ease;

    &::before {
      opacity: 0;
    }

    &::after {
      opacity: 1;
    }

    ${ReadMore} {
      right: 25px;
      opacity: 1;
      transition: 0.3s 0.2s ease;
    }
  }

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    width: 100%;
    height: 100%;
    background: linear-gradient(0deg, #002033 0%, rgba(0, 32, 51, 0) 57.84%),
      linear-gradient(
        0deg,
        rgba(0, 0, 0, 0.958333) 0.01%,
        rgba(0, 0, 0, 0) 100%
      );
    transition: 0.5s ease;
  }

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: 1;
    width: 100%;
    height: 100%;
    background: linear-gradient(0deg, #004775 0%, rgba(0, 71, 117, 0) 54.9%),
      linear-gradient(
        0deg,
        #ff0000 0%,
        rgba(0, 0, 0, 0.958333) 0.01%,
        rgba(0, 0, 0, 0) 100%
      );
    opacity: 0;
    transition: 0.5s ease;
  }
`

export const Image = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100% !important;
  height: 100% !important;
  object-fit: cover;
`

export const Description = styled.div`
  font-size: var(--font-size-index);
`

export const Content = styled.div`
  position: relative;
  z-index: 2;
`

export const Title = styled.h4`
  margin-bottom: 0;
`

export const DateBadge = styled.div`
  font-size: var(--font-size-index);
  font-weight: var(--font-weight-bold);
  color: var(--secondary);
  display: block;
  margin-bottom: 3px;
  text-transform: uppercase;

  i {
    font-size: 130%;
    margin-right: 7px;
  }
`

export const Link = styled.a`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 3;
`

export const ReadMore = styled.span`
  position: absolute;
  bottom: 20px;
  right: 40px;
  z-index: 2;
  font-size: var(--font-size-index);
  font-weight: var(--font-weight-bold);
  color: var(--secondary);
  opacity: 0;
  transition: 0.3s ease;

  i {
    font-size: 130%;
    margin-left: 7px;
    vertical-align: middle;
  }
`
